module.exports = __webpack_public_path__ + "e3c96f3c5802f9ce95031c15a233eb7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/welcome_card.jpg
// module id = 579
// module chunks = 0